import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'

import { debouncedLoadData, sortObjectToString } from 'src/utils/utils'
import Button from '@softwaredev_cegeka/stix-core/dist/components/Button'
import EntityTable from './EntityTable'

import './entityTable.scss'

const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
        const defaultRef = React.useRef()
        const resolvedRef = ref || defaultRef

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate
        }, [resolvedRef, indeterminate])

        return (
            <>
                <input type="checkbox" ref={resolvedRef} {...rest} />
            </>
        )
    }
)

function AppPermissionsTable(props) {
    const {
        data,
        loading,
        params,
        setParams,
        canEdit = false,
        saveAppPermissions,
        checkedActions,
        allActions,
        ...rest
    } = props

    // eslint-disable-next-line no-unused-vars
    const [sort, setSort] = useState({ column: null, direction: null })
    const [selectedRows, setSelectedRows] = useState([])
    const [filterParams, setFilterParams] = useState({})

    useEffect(() => {
        let rows = []
        if (checkedActions) {
            checkedActions.forEach(item => {
                rows.push(item.id)
            })
        }
        setSelectedRows(rows)
    }, [checkedActions])

    const columnsToFilter = [
        {
            column: 'category',
        },
        {
            column: 'key',
        },
        {
            column: 'description',
        },
    ]

    function handleFilterChange(entries) {
        // Reset to show al results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            setFilterParams({})
            return
        }

        const sortString = sortObjectToString(sort)

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                params[key + '_like'] = value.toString()
            })
        })

        if (sortString) {
            params.sort = sortString
        }
        setFilterParams(params)
        setParams(params)
    }

    function handleGlobalFilter(value) {
        if (!value) {
            // Reset to existing filterParams if global filter is cleared
            debouncedLoadData(filterParams, setParams)
            return
        }

        // Combine filterParams with the global filter and update params
        const updatedParams = { ...filterParams, description_like: value }
        setParams(updatedParams)
    }

    function selectAllHandler() {
        if (allActions) {
            setSelectedRows(allActions.map(action => action?.id))
        }
    }

    function rowSelecthandler(row) {
        if (selectedRows.includes(row.selectedRow?.original?.id)) {
            setSelectedRows(
                selectedRows.filter(id => id !== row.selectedRow?.original?.id)
            )
        } else {
            setSelectedRows([...selectedRows, row.selectedRow?.original?.id])
        }
    }

    const columns = [
        {
            Header: 'Namespace',
            accessor: 'service_namespace',
        },
        {
            Header: 'Category',
            accessor: 'category',
        },
        {
            Header: 'Key',
            accessor: 'key',
        },
        {
            Header: 'Description',
            accessor: 'description',
        },
    ]

    if (canEdit) {
        columns.push({
            id: 'id',
            Header: ({ rows }) => (
                <>
                    <IndeterminateCheckbox
                        className="app-permissions-allow-all"
                        checked={
                            selectedRows.length &&
                            allActions.length === selectedRows.length
                        }
                        onChange={e => {
                            if (e.target.checked) {
                                selectAllHandler()
                            } else {
                                setSelectedRows([])
                            }
                        }}
                    />
                    <span>Allow Action</span>
                </>
            ),
            Cell: ({ row }) => (
                <IndeterminateCheckbox
                    checked={selectedRows.includes(row?.original?.id)}
                    readOnly
                />
            ),
            width: '30px',
        })
    }

    return (
        <>
            <div className="data-table-container">
                <EntityTable
                    {...rest}
                    loading={loading}
                    data={data}
                    columns={columns}
                    columnsTofilter={columnsToFilter}
                    onSingleRowSelect={rowSelecthandler}
                    onColumnFilter={handleFilterChange}
                    onGlobalFilter={handleGlobalFilter}
                />
            </div>
            {canEdit && data.length ? (
                <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => saveAppPermissions(selectedRows)}
                >
                    Submit
                </Button>
            ) : null}
        </>
    )
}

export default withRouter(AppPermissionsTable)
